import { api } from "../api";

/**
 * findAllDeviceManufacturersListResponse - Function that finds on database all devices manufacturers as select list response
 * /devices/manufacturers  
 * method GET 
 * @async-function
 */
const findAllDeviceManufacturersListResponse = async (token: string) => {
    const response = await api.get(
        `/devices/manufacturers`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
         }
    );
    return response;
};

export default findAllDeviceManufacturersListResponse;